import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import ProductEditForm from "./ProductEditForm";

const EditProduct = () => {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box py={2}>
        <Typography variant='h5' gutterBottom>
          Edit Product
        </Typography>
        <ProductEditForm />
      </Box>
      <Footer />
    </DashboardLayout>
  );
};

export default EditProduct;
